import {
  getLocaleNumberSymbol,
  getNumberOfCurrencyDigits,
  NumberSymbol,
} from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Question } from '../../../../core/models/questionnaire.model';
import { QuestionAnswer } from '../question/question.component';
import { currencies } from './currencies';

@Component({
  selector: 'app-question-currency',
  templateUrl: './question-currency.component.html',
  styleUrls: ['./question-currency.component.scss'],
})
export class QuestionCurrencyComponent implements OnInit {
  @Input('question') question!: Question;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  curs = currencies;

  val?: string;

  currencyForm = new FormGroup({
    cValue: new FormControl('', Validators.required),
  });
  currency!: string;

  currencyDigits = 2;
  placeholder = '0.00';
  currencyDecimal = '.';
  currencyGroup = ',';

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private locale: string
  ) {
    console.log('locale', this.locale);
  }

  async ngOnInit() {
    this.currencyDecimal = getLocaleNumberSymbol(
      this.locale,
      NumberSymbol.CurrencyDecimal
    );
    this.currencyGroup = getLocaleNumberSymbol(
      this.locale,
      NumberSymbol.CurrencyGroup
    );
    this.placeholder = '0' + this.currencyDecimal + '00';

    console.log('currency dbg', {
      placeholder: this.placeholder,
      currencyDecimal: this.currencyDecimal,
      currencyGroup: this.currencyGroup,
    });

    if (this.question.answer && this.question.answer.value) {
      this.currencyForm.controls.cValue.setValue(
        this.question.answer.value.toString()
      );
      this.currency = this.question.answer.addtional_information.currency;
    } else if (
      this.question.configuration &&
      this.question.configuration.currency
    ) {
      this.currency = this.question.configuration.currency;
    } else {
      this.currency = this.locale === 'pt-BR' ? 'BRL' : 'GBP';
    }
    await new Promise((resolve) => setTimeout(resolve, 100));
    this.change();
  }

  changeCurrency() {
    this.currencyDigits = getNumberOfCurrencyDigits(this.currency);

    this.placeholder = `0${
      this.currencyDigits > 0
        ? this.currencyDecimal + Array(this.currencyDigits).fill('0').join('')
        : ''
    }`;

    this.change();
  }

  change() {
    // console.log('Curr Changed', this);
    // if (!this.val) {
    //   return;
    // }
    // this.changeAnswer.emit({
    //   answer: {
    //     value: Number.parseFloat(this.val),
    //     addtional_information: {
    //       currency: this.currency,
    //     },
    //   },
    //   question: {
    //     ...this.question,
    //     isValid: this.currencyForm.controls.cValue.valid,
    //   },
    // });
    console.log('changes:', {
      answer: {
        value: this.currencyForm.controls.cValue.value,
        addtional_information: { currency: this.currency },
      },
      question: this.question,
    });

    setTimeout(() => {
      this.question.answer!.value = this.currencyForm.controls.cValue?.value;
      this.question.answer!.addtional_information = { currency: this.currency };
      this.question.isValid = this.currencyForm.controls.cValue?.valid;
      this.cdr.detectChanges();
      this.changeAnswer.next({
        answer: {
          value: this.currencyForm.controls.cValue.value,
          addtional_information: { currency: this.currency },
        },
        question: this.question,
      });
    }, 100);
  }
}
